import Model from "../model";
import request from "../../request/request";

export class AutoRule extends Model {
  // 复制自动化规则
  static copy(param: any) {
    return request.post("aiExam/applicationRule/copy", param).then(resp => {
      return resp;
    });
  }
}
